import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/services/app.service';
import { AuthService } from '@app/services/auth.service';
import { HelperService } from '@app/services/helper.service';
import { TranslocoService } from '@jsverse/transloco';
import { finalize } from 'rxjs/operators';


@Component({
  selector: 'app-verify-account',
  standalone: false,
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {
  theme!: string;
  themeConfig: any;
  isError: boolean = false;
  loaded: boolean = false;
  show: any = false;
  isMObile: any;
  token: any;
  details: any;
  language = 'en';

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private appService: AppService,
    private helper: HelperService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {

    this.appService.themeConfig.subscribe(r => {
      this.themeConfig = r;
      this.theme = 'theme-red';
      console.log('User Theme From Service:', this.themeConfig);
    });

    let langData = localStorage.getItem('lang');
    if (langData) {
      this.translocoService.setActiveLang(langData);
    } else {
      this.translocoService.setActiveLang('en');
    }

    this.route.params.subscribe((r: any) => {
      if (r.uuid) {
        this.token = r.uuid;
        this.authService.verifyEmail(this.token).pipe(
          finalize(() =>{
            this.loaded = true;
          })
        ).subscribe((r: any) => {
          if(r.message == "Failed! Token Invalid."){
            this.isError = true;
            this.helper.showSuccessMsg(r.message, 'Error', 3000);
          }
          else{
            this.isError = false;
          }
          
        }, (err: any) =>{
          this.isError = true;
          this.helper.showHttpErrorMsg(err);
        })
      }
    })
  }

  loginPage() {
    this.router.navigate(["/login"]);
  }

  setHeaderBackground(degree = 90, primary = this.themeConfig.bgAndFontColor.login.desktop.bg[0], secondary = this.themeConfig.bgAndFontColor.login.desktop.bg[1]){
    return `linear-gradient(${degree}deg, ${primary}, ${secondary}) !important`;
  }

  setBorder(color: string, isBorder: boolean = this.themeConfig.bgAndFontColor.default.btnBorder){
    if(isBorder){
      return `1px solid ${color} !important`;
    }
    else{
      return ``;
    }
  }

  setBorderRadius(isRadius: boolean, radius = '0px'){
    if(isRadius){
      return '';
    }
    else{
      return radius;
    }
  }

}
